import { z } from "zod";
import { TRAVEL_SCOPES, TRAVEL_STATUSES } from "@/features/expenses/schemas/travel-request.schema";

/// URL search params for `/$slug/expenses/travel` (HRMS-EXP-021). Same scope
/// law as claims and advances: three lenses, `mine` by default, and a forbidden
/// deep link normalises rather than answering with a denial card (Q11).
export const travelRouteSearchSchema = z
  .object({
    scope: z.enum(TRAVEL_SCOPES).catch("mine").default("mine"),
    status: z.enum(TRAVEL_STATUSES).optional().catch(undefined),
    /// Deep links from the approvals inbox land here focused by id. The
    /// detail is a side sheet, not a route (HRMS-EXP-021).
    focus: z.string().optional().catch(undefined),
  })
  .strict();
export type TravelRouteSearch = z.infer<typeof travelRouteSearchSchema>;
